export default __webpack_public_path__ + "static/media/icon1@3x_.c4215cea.png";